import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useState } from 'react'
import { Fragment } from 'react/jsx-runtime'
import { useGetCfQuery } from '../features/ricerca/ricercaAPI'
import { TabFormuleObj } from '../features/ricerca/ricercaSlice'

export const PopupMessage = ({ codice }: { codice: string }) => {
    const { data: cfData } = useGetCfQuery()

    const [popupOpen, setPopupOpen] = useState(true)

    const tabFormule: Array<TabFormuleObj> | null = cfData?.data?.tabFormule ?? null

    return tabFormule?.map((it) => (
        <Fragment key={it.CODICE}>
            {it.CODICE == codice && it.FORMULA && it.FORMULA.length > 0 && (
                <Dialog open={popupOpen} onClose={() => setPopupOpen(false)}>
                    <DialogTitle>{it.DESCRIZIONE}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>{it.FORMULA}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setPopupOpen(false)} variant="contained">
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </Fragment>
    ))
}
